export default __webpack_public_path__ + "static/media/pdf_thumbnail_paper.46e21cdb.jpg";